import { render, staticRenderFns } from "./PosLogin.vue?vue&type=template&id=522a60c7&scoped=true&"
import script from "./PosLogin.vue?vue&type=script&lang=js&"
export * from "./PosLogin.vue?vue&type=script&lang=js&"
import style0 from "./PosLogin.vue?vue&type=style&index=0&id=522a60c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a60c7",
  null
  
)

export default component.exports